function AdminSettingsPoliciesCancellationsController(
  UserService,
  PoliciesModel,
  PoliciesStoreService,
  FlashService,
) {
  const vm = this;
  vm.currentUser = UserService.getCurrentUser();
  vm.processPolicy = processPolicy;
  vm.addCancellationRule = addCancellationRule;
  vm.removeCancellationRule = removeCancellationRule;
  vm.school = vm.currentUser.school;
  vm.cancellationRules = [];
  vm.cancellation_rule = {
    hours: "12 Hours",
    fee: null,
  };

  init();

  function init() {
    const cancellationsPolicy = PoliciesStoreService.getPolicy("cancellations");
    vm.policies = { cancellations: { id: 0, policymeta: {} } };
    if (cancellationsPolicy) {
      const policymeta = { ...cancellationsPolicy.policymeta };
      policymeta.fee = parseInt(policymeta.fee);
      policymeta.id = cancellationsPolicy.id;
      if (typeof policymeta.cancellation_rules !== "undefined") {
        policymeta.cancellation_rules = JSON.parse(
          policymeta.cancellation_rules,
        );
        vm.cancellationRules = policymeta.cancellation_rules;
      }
      vm.policies.cancellations = {
        id: cancellationsPolicy.id,
        policymeta,
      };
    }
  }

  function addCancellationRule() {
    if (vm.cancellation_rule.fee && vm.cancellation_rule.hours) {
      vm.cancellationRules.push({
        fee: vm.cancellation_rule.fee,
        hours: vm.cancellation_rule.hours,
      });

      vm.cancellation_rule = {
        fee: null,
        hours: "12 Hours",
      };
    }
  }

  function removeCancellationRule(index) {
    vm.cancellationRules.splice(index, 1);
  }

  function processPolicy(isValid) {
    if (isValid) {
      const payload = Object.assign({}, vm.policies.cancellations.policymeta);
      if (vm.cancellationRules.length > 0) {
        payload.cancellation_rules = vm.cancellationRules;
      }

      PoliciesModel.update(payload).then((response) => {
        FlashService.setMessage({ type: "success", message: response.message });
        PoliciesStoreService.writePolicy("cancellations", payload);
      });
    } else {
      FlashService.setMessage({
        type: "error",
        message: "All fields are required.",
      });
    }
  }
}
AdminSettingsPoliciesCancellationsController.$inject = [
  "UserService",
  "PoliciesModel",
  "PoliciesStoreService",
  "FlashService",
];

export default AdminSettingsPoliciesCancellationsController;
